/** @param {Record<string, unknown>} n */
export function getNotificationTimestampMs(n) {
  const t = n?.updatedAt ?? n?.createdAt;
  if (t == null) return 0;
  const ms = new Date(t).getTime();
  return Number.isFinite(ms) ? ms : 0;
}

/**
 * @param {Record<string, unknown>} n
 * @param {number} viewedAtMs
 */
export function isNotificationUnread(n, viewedAtMs) {
  if (n && n.read === true) return false;
  const ts = getNotificationTimestampMs(n);
  if (!viewedAtMs || viewedAtMs <= 0) return ts > 0;
  return ts > viewedAtMs;
}
